module.exports = __webpack_public_path__ + "assets/img/empty-appoint.3397369b.png";